module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('meta', {
    attrs: {
      "content": "text/html; charset=utf-8",
      "http-equiv": "Content-Type"
    }
  }), _c('meta', {
    attrs: {
      "content": "text/html; charset=UTF-8"
    }
  }), _c('title', [_vm._v("THE CANOPY")]), _c('link', {
    attrs: {
      "href": "default.css",
      "rel": "stylesheet",
      "type": "text/css"
    }
  }), _c('link', {
    attrs: {
      "href": "page-template.xpgt",
      "rel": "stylesheet",
      "type": "application/vnd.adobe.page-template+xml"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "tx2",
    attrs: {
      "id": "page5"
    }
  }, [_vm._v("Do not be afraid of the terrors of the night,")]), _vm._v(" "), _c('p', {
    staticClass: "tx3",
    attrs: {
      "id": "p0005-02-1"
    }
  }, [_vm._v("nor fear the dangers of the day,")]), _vm._v(" "), _c('p', {
    staticClass: "tx2",
    attrs: {
      "id": "p0005-P-1"
    }
  }, [_vm._v("nor dread the plague that stalks in darkness . . .")]), _vm._v(" "), _c('p', {
    staticClass: "tx2",
    attrs: {
      "id": "p0005-P-2"
    }
  }, [_vm._v("If you make the L"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ORD")]), _vm._v(" your refuge,")]), _vm._v(" "), _c('p', {
    staticClass: "tx3",
    attrs: {
      "id": "p0005-P-3"
    }
  }, [_vm._v("if you make the Most High your shelter,")]), _vm._v(" "), _c('p', {
    staticClass: "tx2",
    attrs: {
      "id": "p0005-P-4"
    }
  }, [_vm._v("no evil will conquer you;")]), _vm._v(" "), _c('p', {
    staticClass: "tx3",
    attrs: {
      "id": "p0005-P-5"
    }
  }, [_vm._v("no plague will come near your dwelling . . . "), _c('br'), _c('br')]), _vm._v(" "), _c('p', {
    staticClass: "tx2",
    attrs: {
      "id": "p0005-P-7"
    }
  }, [_vm._v("He will not let you stumble and fall;")]), _vm._v(" "), _c('p', {
    staticClass: "tx3",
    attrs: {
      "id": "p0005-P-8"
    }
  }, [_vm._v("the one who watches over you will not sleep. "), _c('br'), _c('br')]), _vm._v(" "), _c('p', {
    staticClass: "txr",
    attrs: {
      "id": "p0005-03-2"
    }
  }, [_vm._v("—P"), _c('span', {
    staticClass: "small"
  }, [_vm._v("SALMS 91:5–6, 9–10; 121:3")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-cbe32110","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/chapter3.vue
// module id = 72
// module chunks = 0